var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { BaseApi } from '../baseApi';
export default class AccountsApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'api/v1/accounts';
    }
    getAccounts(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, { signal } = {}) {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}`,
                params,
                signal,
            });
        });
    }
    getAllEnvironmentAccounts(environmentId_1, params_1) {
        return __awaiter(this, arguments, void 0, function* (environmentId, params, { signal } = {}) {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}/${environmentId}/environment-accounts-list`,
                params,
                signal,
            });
        });
    }
    getEnvironmentAccount(environmentId_1, accountId_1) {
        return __awaiter(this, arguments, void 0, function* (environmentId, accountId, { signal } = {}) {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}/${environmentId}/environment-account/${accountId}`,
                signal,
            });
        });
    }
    createEnvironmentAccount(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { environmentId } = data, restData = __rest(data, ["environmentId"]);
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}/${environmentId}/environment-account`,
                data: restData,
            });
        });
    }
    updateEnvironmentAccount(environmentId, accountId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.apiBasePath}/${environmentId}/environment-account/${accountId}`,
                data,
            });
        });
    }
    enableEnvironmentAccount(environmentId, accountId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.apiBasePath}/${environmentId}/environment-account/${accountId}/enable`,
            });
        });
    }
    disableEnvironmentAccount(environmentId, accountId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.apiBasePath}/${environmentId}/environment-account/${accountId}/disable`,
            });
        });
    }
}
//# sourceMappingURL=index.js.map